import TransactionTab from './TransactionTab.vue';

export default TransactionTab;
